export default __webpack_public_path__ + "static/media/village.6533b034.png";